import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { LoginService } from './Login.service';
import { SessionService } from './Session.service';
import { CommonDataService } from './common-data.service';

@Injectable({
  providedIn: 'root'
})

export class InternalAdminViewRouteGuardService implements CanActivate {

  constructor(private router: Router, private _loginService: LoginService, private commonservice: CommonDataService, private activatedRoute: ActivatedRoute, private session: SessionService, public commonDataService: CommonDataService) { } activate: boolean = true;
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    if (this.session.userInfo == undefined || this.session.userInfo == null || this.session.userInfo.user == null) {
      await this._loginService.getSession().toPromise().then(data => {
        if (data != null && data.user != null && (!this.router.url.includes("Login"))) {
          this.session.assignUserInfo(data.user);
          this.checkSession()
          localStorage.removeItem("DeepLinkRoute");
        }
        else {
          localStorage.setItem("DeepLinkRoute", route.url.map(x => x.path).join("/"));
          this.notifyUnAuthorizedAccess();
          this.activate = false;

        }
      });
    }
    else {
      localStorage.removeItem("DeepLinkRoute");
      this.activate = this.checkSession()
    }
    return this.activate

  }
  checkSession() {
    if (this.session.userInfo != null && this.session.userInfo.user != null && this.session.userInfo.user.roles == "Professional" && this.session.userInfo.user.isAdmin) {
      localStorage.setItem("showLoginValidation", "true");
      this.activate = true;
    }
    else {
      this.notifyUnAuthorizedAccess();
      this.activate = false;
    }
    return this.activate
  }
  notifyUnAuthorizedAccess() {
    let obj = {
      type: 'error',
      displayTime: 3000,
      position: 'bottom',
      message: "You are not authorized , please log in"
    }
    this._loginService.deleteSession().subscribe();
    this.session.assignUserInfo(null);
    this.commonservice.notificationObject.next(obj);
    this.router.navigate(['Login']);
  }
}
